import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import WhiteboardController from '../../controllers/WhiteboardController';
import type * as AhaButton from '@aha-app/aha-base/dist/types/components/aha-button/types';

interface DrawerLinkProps {
  kind?: AhaButton.Kind;
  outline?: boolean;
  path: string;
  children: React.ReactNode;
}

const DrawerLink: React.FC<DrawerLinkProps> = ({
  kind = 'link',
  outline = false,
  path,
  children,
}) => {
  const controller = useController(WhiteboardController);

  return (
    <aha-button
      kind={kind}
      outline={outline || null}
      onClick={() => controller.actionShowDrawerPath(path)}
    >
      {children}
    </aha-button>
  );
};

export default ApplicationView(DrawerLink);
